<template>
  <div class="min-h-screen bg-gray-100">
    <navbar class="bg-white shadow"/>
    <!-- main view end -->
    <div class="flex bg-gray-100">
      <sidebar v-show="auth.result === 'ok'" :hiddensidebar="hiddensidebar"/>
      <div class="flex flex-col flex-1">
        <main class="flex-1 relative focus:outline-none" tabindex="0">
          <div class="pt-2 pb-6 md:py-2">
            <div class="mx-auto px-4 sm:px-6 md:px-8">
              <div class="py-4">
                <router-view />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <loading-notification v-if="$store.getters.isLoading"/>
  </div>
</template>
<script>
import Navbar from '@/components/Navbar/Navbar'
import Sidebar from '@/components/Sidebar/Sidebar'
import LoadingNotification from '@/components/LoadingNotification';

export default {
  name: 'app',
  components: { Navbar, Sidebar, LoadingNotification },
  data() {
    return {
      hiddensidebar: true //TODO: maybe a watch on auth to trigger the update?
    }
  },
  computed: {
    auth() {
      return this.$store.getters.auth
    }
  },
  methods: {
    toggleSidebar() {
      this.hiddensidebar = !this.hiddensidebar
    }
  }

}
</script>
